import { render, staticRenderFns } from "./UserVideoRateTable.vue?vue&type=template&id=d4b27c14&"
import script from "./UserVideoRateTable.vue?vue&type=script&lang=js&"
export * from "./UserVideoRateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports